import {
  RudderstackIntegrations,
  USER_GEO_IP_LOCATION_KEY,
} from 'constants/common'
import { RudderEvent } from 'constants/rudderEvents'
import { getUserLocation } from './common'

type Integrations = {
  [key in RudderstackIntegrations]?: boolean
}

const logEvent = (
  eventName: RudderEvent,
  data = {},
  integrations?: Integrations,
  retryCount = 0
): void => {
  const defaultIntegrations = {
    [RudderstackIntegrations.GOOGLE_ADS]: false,
    [RudderstackIntegrations.GOOGLE_TAG_MANAGER]: false,
    [RudderstackIntegrations.FACEBOOK_PIXEL]: false,
    ...(!!integrations && integrations),
  }

  if (globalThis.rudderanalytics) {
    const userLocation = getUserLocation()
    globalThis.rudderanalytics.track(
      eventName,
      data,
      userLocation && {
        integrations: defaultIntegrations,
        location: {
          [USER_GEO_IP_LOCATION_KEY]: userLocation,
        },
      },
      { integrations: defaultIntegrations }
    )
  } else {
    // When there is an event that's fired on component mount, there is a chance where the log event doesn't get triggered
    // So to avoid that we retry the event after a small delay
    const maxRetries = 5

    if (retryCount > maxRetries) {
      // eslint-disable-next-line no-console
      console.error(
        'logEvent failed after maximum retries, rudderanalytics not initialized'
      )
      return
    }

    setTimeout(() => {
      logEvent(eventName, data, integrations, ++retryCount)
    }, 50)
    return
  }

  // Also send all events to Heap https://thriveworks.atlassian.net/browse/THRIV-4731
  if (process.env.NEXT_PUBLIC_HEAP_APP_ID && globalThis.heap) {
    globalThis.heap.track(eventName, data)
  }
}

export default logEvent
